import dayjs from 'dayjs';

import type { CreditNote } from '~/api/creditNotes/types';

import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  creditNote: CreditNote;
};

export const CreditNoteDocumentDateCell = ({ creditNote }: Props) => {
  return <span className={desktopTruncateStyle}>{dayjs(creditNote.documentDate).format('DD/MM/YYYY')}</span>;
};
